import { AutocompleteInput, ReferenceInput, SelectInput } from 'react-admin'
import { UTILITY_TARIFF_SECTOR_CHOICES } from '../common'
import { TARIFF_CATALOGUE_LIST_DATASET_CHOICES } from '../tariffDatasetScopes'
import { catalogFilterFieldStyle } from './utilityTariffCatalogStyles'

const filterOptions = { style: catalogFilterFieldStyle }

export function getUtilityTariffCatalogFilterFieldElements() {
  return [
    <SelectInput
      key="tariff_dataset"
      label="Tariff Dataset Type"
      source="tariff_dataset"
      options={filterOptions}
      choices={[...TARIFF_CATALOGUE_LIST_DATASET_CHOICES]}
    />,

    <ReferenceInput
      key="country"
      source="country"
      label="Country"
      reference="countries"
      sort={{ field: 'name', order: 'ASC' }}
    >
      <AutocompleteInput
        source="country"
        fullWidth={false}
        translateChoice={false}
        options={{ ...filterOptions, placeholder: 'Enter a country' }}
        optionText="name"
        optionValue="id"
      />
    </ReferenceInput>,
    <ReferenceInput
      key="utility"
      source="utility"
      label="Utility"
      reference="utilities"
      sort={{ field: 'name', order: 'ASC' }}
    >
      <AutocompleteInput
        source="utility"
        fullWidth={false}
        translateChoice={false}
        options={{ ...filterOptions, placeholder: 'Utility' }}
        optionText="name"
        optionValue="id"
      />
    </ReferenceInput>,
    <ReferenceInput
      key="distributor"
      source="distributor"
      label="Distributor"
      reference="distributors"
      sort={{ field: 'name', order: 'ASC' }}
    >
      <AutocompleteInput
        source="distributor"
        fullWidth={false}
        translateChoice={false}
        options={{ ...filterOptions, placeholder: 'Distributor' }}
        optionText="name"
        optionValue="id"
      />
    </ReferenceInput>,
    <SelectInput
      key="popularity_filter"
      source="popularity_filter"
      label="Popularity Filter"
      options={filterOptions}
      choices={[
        { id: 'min', name: 'Min (0)' },
        { id: 'low', name: 'Low (1 - 19)' },
        { id: 'med', name: 'Medium (20 - 59)' },
        { id: 'high', name: 'High (60 - 99)' },
        { id: 'max', name: 'Max (100)' },
      ]}
    />,
    <SelectInput
      key="sector"
      source="sector"
      label="Sector"
      options={filterOptions}
      choices={UTILITY_TARIFF_SECTOR_CHOICES}
    />,
  ]
}
